export class MemberProfileMail {

      RECORD_ID:string;
      PROFILE_ID:string;
      MEMBER_TMC:string;
      MEMBER_NAME:string;
      MEMBER_DESIGNATION:string;
      MESSAGE1:string;
      MESSAGE2:string;
      MESSAGE3:string;
      MESSAGE4:string;
      MESSAGE5:string;
      MESSAGE6:string;
      MESSAGE7:string;
      SUBMISSION_DATE:string;
      MESSAGE_SUBMISSION_BY:string;
      MESSAGE_SUBMISSION_DATE:string;
      MESSAGE_CREATED_BY:string;
      MESSAGE_CREATED_ON:string;
      MODIFIED_BY:string;
      MODIFIED_ON:string;
}
